import React from 'react';
import Payment from 'routes/Profile/components/ProfileContent/Payment';

import { IStepComponentProps } from './types';

const PaymentAddressWizard: React.FC<IStepComponentProps> = ({
  userInfo,
  buttonLabel,
  isActive,
  saveButtonContainerClass,
  onClickNext,
  refetch,
}) => {
  const onSubmit = () => {
    onClickNext?.();
  };

  return (
    <Payment
      user={userInfo}
      portalButtonClassName={saveButtonContainerClass}
      submitButtonLabel={buttonLabel}
      hideSaveButton={!isActive}
      onSubmitCallback={onSubmit}
      showNotificationOnSuccess={false}
      refetchUserData={refetch}
    />
  );
};

export default React.memo(PaymentAddressWizard);
